<h1 mat-dialog-title>Change Shipper</h1>
<div mat-dialog-content>
  <form [formGroup]="newShipperInfoForm">
    <mat-form-field style="width: 100%;">
      <mat-label>New Shipper</mat-label>
      <input
        type="text"
        matInput
        formControlName="new_shipper_control"
        [matAutocomplete]="auto"
        placeholder="Type at least 3 letters"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="onShipperSelected($event.option.value)"
      >
        <mat-option *ngFor="let shipper of filteredShipperList | async" [value]="shipper">
          {{ shipper.label }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field style="width: 100%;" *ngIf="addresses.length > 0">
      <mat-label>Select Shipper Address</mat-label>
      <mat-select formControlName="shipper_address_uuid" (selectionChange)="onAddressSelected($event.value)">
        <mat-option *ngFor="let addr of addresses" [value]="addr.contact_address_uuid">
          {{ addr.address }} {{ addr.address_extended ? addr.address_extended : '' }},
          {{ addr.locality }}, {{ addr.region }} {{ addr.postal_code }}, {{ addr.country }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="primary" (click)="onSubmit()">Submit</button>
</div>